import React from 'react';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import ChampSelect from '../ui/ChampSelect';
import { EXAMENS_NATIONAUX } from '../../config/examensConfig';

/**
 * Fil d'Ariane des écrans d'examens, avec commutateur.
 *
 * La tablist a cédé la place à un drill-in depuis le tableau de bord. Mais le
 * drill-in seul obligerait à remonter d'un cran pour passer du CEPE au BEPC :
 * en période d'inscriptions, les dossiers se traitent en parallèle. Le
 * commutateur rend ce saut aussi direct que l'ancienne tablist, sans occuper
 * une barre permanente en haut de chaque écran.
 *
 * `enfant` ajoute un dernier niveau non cliquable — le nom d'un candidat.
 */
const DESTINATIONS = [
  ...Object.values(EXAMENS_NATIONAUX).map((ex) => ({
    valeur: ex.code,
    libelle: ex.libelleLong
  })),
  { valeur: 'CANDIDATS_LIBRES', libelle: 'Candidats libres' },
  { valeur: 'RESULTATS_DEVENIR', libelle: 'Résultats et devenir' }
];

const FilArianeExamen = ({
  codeCourant,
  libelleCourant,
  onRetour,
  onChangerExamen = null,
  // Remontée d'un cran depuis le dossier d'un candidat, vers la liste.
  onRetourNiveau = null,
  enfant = null,
  precisionEnfant = null
}) => (
  <div className="mb-4 flex flex-wrap items-center gap-2">
    {/* Retour en bouton plutôt qu'en lien : c'est l'action de sortie de
        l'écran, elle doit se voir comme les autres retours de l'application. */}
    <Button
      variant="outline"
      size="sm"
      onClick={onRetour}
      className="gap-1.5 border-[#246990] text-[#246990] hover:bg-[#246990] hover:text-white"
    >
      <ArrowLeft size={15} />
      Examens
    </Button>

    <ChevronRight size={14} className="flex-shrink-0 text-gray-300" />

    {onChangerExamen && !enfant ? (
      <ChampSelect
        valeur={codeCourant}
        onChange={onChangerExamen}
        options={DESTINATIONS}
        className="w-auto min-w-[200px] border-transparent bg-transparent font-semibold text-[#246990] shadow-none hover:border-gray-200"
      />
    ) : enfant ? (
      // Sur le dossier d'un candidat, le niveau parent redevient une remontée
      // vers la liste — un sélecteur y proposerait de changer d'examen tout en
      // gardant affiché un dossier qui n'y appartient pas.
      //
      // En bouton, pas en lien : c'est une action de navigation, elle doit se
      // voir comme le retour aux examens juste à côté.
      <Button
        variant="outline"
        size="sm"
        onClick={onRetourNiveau || onRetour}
        className="gap-1.5 border-[#246990] text-[#246990] hover:bg-[#246990] hover:text-white"
      >
        <ArrowLeft size={15} />
        {libelleCourant}
      </Button>
    ) : (
      <span className="text-sm font-semibold text-[#246990]">{libelleCourant}</span>
    )}

    {enfant && (
      <>
        <ChevronRight size={14} className="flex-shrink-0 text-gray-300" />
        <span className="text-sm text-gray-600">{enfant}</span>
        {precisionEnfant && (
          <span className="text-sm text-gray-400">· {precisionEnfant}</span>
        )}
      </>
    )}
  </div>
);

export default FilArianeExamen;
